module.exports = __webpack_public_path__ + "img/gs1.b0d07191.svg";